import { modalManagerPlugin } from '@pizzahutau/vue-bootstrap-components'

export default {
  install (app) {
    app.use(modalManagerPlugin)
  }
}